function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M42.91 11.38h6.57c2.39 0 4.39 2 4.39 4.39v33.92",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.09 60.86h-28.51c-2.39 0-4.58-2-4.61-4.39v-40.51c0-2.39 2-4.58 4.39-4.58h6.6",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.91 60.86v-6.6c0-2.39 2-4.39 4.38-4.39h6.58",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.56 27.93h21.95",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.56 38.92h27.32",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.56 49.88h10.99",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.91 60.86l10.96-11.17",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.51 8.78v-2.79h-10.96v2.79h-5.59v8.16h21.95v-8.16z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));

var SvgTaskList = function SvgTaskList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTaskList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/task_list.43b64844.svg";
export { ForwardRef as ReactComponent };